import { Box } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { TitleDivider } from "../titleDivider";
import { NeighborhoodForm } from "../neighborhoodForm";
import { observer } from "mobx-react";
import { InternalValuationReviewStore } from "../../stores/internalValuationReviewStore";

const useStyles = makeStyles((theme: Theme) => ({
  tabContent: {
    backgroundColor: "#FFFFFF",
    padding: "2rem",
  },
}));

interface NeigborhoodTabProps {
  internalValuationReviewStore: InternalValuationReviewStore;
}

export const NeigborhoodTab = observer(({ internalValuationReviewStore }: NeigborhoodTabProps) => {
  const classes = useStyles();

  const readOnly = internalValuationReviewStore.readOnly;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap="1rem"
      className={classes.tabContent}
    >
      <TitleDivider title="Neighborhood & Housing Conditions" />
      <NeighborhoodForm neighborhoodFormStore={internalValuationReviewStore.neighborhoodFormStore} readOnly={readOnly} />
    </Box>
  );
});
